import {
  buildPortalUrl,
  getAuthAudienceForContext,
  getCookieCleanupOptionsForContext,
  getCookieOptionsForContext,
  getSupabaseCookieCleanupOptionsForContext,
  getSupabaseCookieNames,
  getSupabaseCookieOptionsForContext,
  parseHostContext,
  type AuthAudience,
  type HostContext,
  type HostCookieOptions,
  type SupabaseCookieOptions,
} from './host-context';

export function getBrowserHostContext(): HostContext | null {
  if (typeof window === 'undefined')
    return null;

  return parseHostContext(window.location.host, {
    protocol: window.location.protocol === 'http:' ? 'http' : 'https',
  });
}

export function getBrowserCookieOptions(): HostCookieOptions | undefined {
  const context = getBrowserHostContext();
  return context ? getCookieOptionsForContext(context) : undefined;
}

export function getBrowserCookieCleanupOptions(): HostCookieOptions[] {
  const context = getBrowserHostContext();
  if (!context)
    return [];

  return getCookieCleanupOptionsForContext(context);
}

export function getBrowserAuthAudience(): AuthAudience {
  return getAuthAudienceForContext(getBrowserHostContext());
}

export function getBrowserSupabaseCookieOptions(
  audience: AuthAudience = getBrowserAuthAudience(),
): SupabaseCookieOptions | undefined {
  const context = getBrowserHostContext();
  return context ? getSupabaseCookieOptionsForContext(context, audience) : undefined;
}

export function getBrowserSupabaseCookieCleanupOptions(
  audience: AuthAudience = getBrowserAuthAudience(),
): SupabaseCookieOptions[] {
  const context = getBrowserHostContext();
  return context ? getSupabaseCookieCleanupOptionsForContext(context, audience) : [];
}

export function getBrowserSupabaseCookieNames(
  audience: AuthAudience = getBrowserAuthAudience(),
): string[] {
  if (typeof document === 'undefined')
    return [];

  return getSupabaseCookieNames(document.cookie, process.env.NEXT_PUBLIC_SUPABASE_URL, audience);
}

export function buildBrowserPortalUrl(
  portalSlug: string | null | undefined,
  mode: 'durable' | 'preview-display' = 'durable',
): string {
  const context = getBrowserHostContext();
  if (!context || !portalSlug)
    return '';

  return buildPortalUrl(portalSlug, context, mode);
}
